import { CSSObject } from '@emotion/react'

export const TOOLTIP_TRANSITION_TIME_MS = 200

export interface TooltipStyles {
  styles?: Partial<Record<'tooltip' | 'content', CSSObject>>
}
